var map = {
	"./1.jpg": 35790,
	"./10.jpg": 46356,
	"./11.jpg": 60689,
	"./12.jpg": 32934,
	"./13.jpg": 92419,
	"./14.jpg": 99792,
	"./2.jpg": 16057,
	"./3.jpg": 45532,
	"./4.jpg": 47079,
	"./5.jpg": 79338,
	"./6.jpg": 71413,
	"./7.jpg": 67096,
	"./8.jpg": 24707,
	"./9.jpg": 12217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18034;